// extracted by mini-css-extract-plugin
export const banner = "GalleryCollection-module--banner--166XT";
export const ProductContainer = "GalleryCollection-module--ProductContainer--2Oxbw";
export const JoinMemberFormContainer = "GalleryCollection-module--JoinMemberFormContainer--Th8RD";
export const TopSection = "GalleryCollection-module--TopSection--CZWYu";
export const loading = "GalleryCollection-module--loading--11Z3D";
export const loadingGif = "GalleryCollection-module--loadingGif--Ognnu";
export const ProductAndForm = "GalleryCollection-module--ProductAndForm--2Zw3n";